import './App.css';
import { Scrapper } from './pages/Scrapper';

function App() {
  return (
    <>
      <Scrapper />
    </>
  );
}

export default App;
